<template>
  <div>
    <TopBar :page="topBarData" @addBtnClick="addBtnClicked"/>
    <v-container fluid>
      <template v-if="dataLoading"><v-row><v-col><loader/></v-col></v-row></template>
      <template v-if="!dataLoading">
        <v-row class="pt-4">
          <v-col>
            <v-card>
              <v-card-text>
                <h3 class="mb-5 accent--text">Saved vs Lost</h3>
                <line-chart :series="saved.series" :x_axis="saved.xaxis"></line-chart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <h3 class="mb-5 accent--text">Cancellation Reasons</h3>
                <bar-chart :series="cancellations.series" :x_axis="cancellations.xaxis"></bar-chart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <h3 class="mb-5 accent--text">Departments</h3>
                <bar-chart :series="departments.series" :x_axis="departments.xaxis"></bar-chart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-container>

    <v-dialog width="350" v-model="openFilter">
      <v-card>
        <v-card-title>Filter</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-menu ref="menu" v-model="filterOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filterText" label="Filter by date" prepend-inner-icon="event" readonly hide-details dense outlined v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker range no-title v-model="filter" color="accent" :min="(filter[0]!==undefined)?filter[0]:''">
                  <v-spacer></v-spacer>
                  <v-btn v-if="filter.length!==0" text color="error" @click="filter=[];">Clear</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small outlined class="ml-3" @click="openFilter=false;">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState,mapActions } from "vuex";

  import LineChart from "@/components/Charts/LineChart";
  import BarChart from "@/components/Charts/BarChart";
  import Loader from "@/components/Misc/Loader";
  import TopBar from "@/components/Layout/TopBar";

  export default {
    components: { BarChart,LineChart,Loader,TopBar },
    data(){
      return {
        topBarData: {
          name: 'Retention Leads',
          type: 'retention',
          showSearch: true,
          menu: false,
          breadcrumbs: [],
          additionalButtons: [
            {
              inner: 'filter',
              color: 'secondary',
              method: 'openFilter',
            }
          ],
          showBeehiveIcon: false,
        },
        filter: [],
        filterOpen: false,
        dataLoading: true,
        saved: {series:[],xaxis:{categories:[]}},
        cancellations: [],
        departments: [],
        openFilter: false
      };
    },
    computed: {
      ...mapState("retention", ["retentionReports"]),
      filterText(){
        let joint = this.filter.join(' - ');
        this.topBarData.breadcrumbs = [{
          text: joint,
          disabled: true,
          href: '#',
        }];
        return joint;
      },
    },
    methods: {
      ...mapActions("retention", ["getRetentionReports"]),
      addBtnClicked(btnName){
        switch(btnName){
          case 'openFilter':
            this.openFilter = true;
            break
        }
      },
      getReportsfiltered(){
        this.filterOpen = false;
        this.dataLoading = true;
        this.saved = {series:[],xaxis:{categories:[]}};
        this.cancellations = {series:[{name:'Total',data:[]}],xaxis:{categories:[]}};
        this.departments = {series:[{name:'Total',data:[]}],xaxis:{categories:[]}};
        let dates = {
          start: (this.filter[0]!==undefined)?this.filter[0]:'',
          end: (this.filter[1]!==undefined)?this.filter[1]:'',
        };
        this.getRetentionReports(dates).then(()=>{
          let int = setInterval(()=>{
            if(this.retentionReports[0]!==undefined){
              clearInterval(int);
              let saved = this.retentionReports[0].data;
              let xaxis = [];
              saved.forEach((it)=>{
                let preSeries = { name: it.seriesname, data: [] }
                if(this.saved.xaxis.categories.length===0){
                  it.data.forEach((d)=>{ xaxis.push(d.date); preSeries.data.push(d.value); });
                  this.saved.xaxis.categories = xaxis;
                }else{
                  it.data.forEach((d)=>{ preSeries.data.push(d.value); });
                }
                this.saved.series.push(preSeries);
              });
              
              xaxis = [];
              let cancellations = this.retentionReports[1].data;
              Object.keys(cancellations).forEach((k)=>{
                this.cancellations.series[0].data.push(cancellations[k]);
                this.cancellations.xaxis.categories.push(k);
              });

              xaxis = [];
              let departments = this.retentionReports[2].data;
              Object.keys(departments).forEach((k)=>{
                this.departments.series[0].data.push(departments[k]);
                this.departments.xaxis.categories.push(k);
              });

              this.dataLoading = false;
            }
          },200);
        });
      }
    },
    watch:{
      filter(val) {
        if(val.length===0||val.length==2){
          this.getReportsfiltered();
          this.filterOpen = false;
          this.openFilter = false;
        }
      },
    },
    mounted(){
      this.getReportsfiltered();
    },
  };
</script>

<style lang="scss" scoped>
  .v-menu__content { z-index: 1000 !important; }
</style>
